/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './leaderboard-mini.stache';

const leaderboardLink = window.globalSettings.pagePaths.leaderboard;

Component.extend({
    tag: 'live-leaderboard-mini',
    template,
    viewModel: {
        emptyFavoritesList: false,
        leaderboardLink: leaderboardLink,
        activeTab: 'leaders',
        define: {
            getFavoritePlayers: {
                get() {
                    let favorites = this.attr('favorites') || [];

                    if (favorites.length == 0) {
                        this.attr('emptyFavoritesList', true);
                    } else {
                        if (favorites.length < 5) {
                            let numberOfEmptyLines = 5 - favorites.length;
                            favorites = favorites.concat(
                                new Array(numberOfEmptyLines),
                            );
                        } else {
                            favorites = favorites.slice(0, 5);
                        }
                        this.attr('emptyFavoritesList', false);
                    }

                    return favorites;
                },
            },
        },
    },
    events: {
        '.s-controls-item click': function(event) {
            if (!$(event.context).hasClass('is-selected')) {
                this.viewModel.attr('activeTab', $(event.context).data('tab'));
            }
        },
    },
});
